import type { PocInputValidity } from 'commons/types';
import { ExtendedValidationMessages, Select, SelectOption } from 'commons/components';
import { IdentityProviderMapping } from 'modules/settings/pods/settings-integrations/settings-integrations-active-directory/types/active-directory.type';

type SelectDataPointType = {
    pocFieldInputName: string;
    pocFieldInputValue: string;
    pocFieldInputDisabled: boolean;
    pocInputOptions: SelectOption[];
    pocFieldInputSelectValidity: PocInputValidity | undefined;
    pocFieldInputOptions: SelectOption[];
    identityProviderIndex: number;
    validationMessages: ExtendedValidationMessages;
    setPocFieldInputSelectValidity: React.Dispatch<React.SetStateAction<PocInputValidity | undefined>>;
    onChangeIdentityProviderMapping: <K extends keyof IdentityProviderMapping>(
        index: number,
        field: K,
        value: IdentityProviderMapping[K]
    ) => void;
};

export const SelectDataPoint: React.FC<SelectDataPointType> = (props) => {
    const {
        pocFieldInputName,
        pocFieldInputValue,
        pocInputOptions,
        pocFieldInputSelectValidity,
        pocFieldInputOptions,
        pocFieldInputDisabled,
        identityProviderIndex,
        validationMessages,
        onChangeIdentityProviderMapping,
        setPocFieldInputSelectValidity,
    } = props;

    return (
        <Select
            className="without-label"
            name={pocFieldInputName}
            placeholder="settings.integrations.active-directory.data-points.mapping.poc.placeholder"
            value={pocFieldInputValue}
            options={pocInputOptions}
            validationMessages={validationMessages}
            validity={pocFieldInputSelectValidity}
            onValidity={(_field, value) => {
                if (pocFieldInputOptions?.some((option) => option.value === pocFieldInputValue)) {
                    setPocFieldInputSelectValidity(value);
                }
            }}
            onChange={(_field, value) => {
                onChangeIdentityProviderMapping(identityProviderIndex, 'operatorField', value?.[0] as string);
                if (pocFieldInputOptions?.some((option) => option.value === (value?.[0] as string))) {
                    setPocFieldInputSelectValidity({ state: 'valid' });
                }
            }}
            disabled={pocFieldInputDisabled}
            customKeyItemPrefix={`ldapMappingPocField${identityProviderIndex}`}
        />
    );
};
